import { adminRequestsTyped } from "@/api/(requests)/adminTyped";
import type { CreateProviderBody } from "@/core/types";

export async function createProvider(body: CreateProviderBody): Promise<void> {
  return adminRequestsTyped.create_user({ body });
}
